<template>
	<div>
		<h5>
			<span v-if="nearbyStores.length">
				{{ $tc('foundNearByStore', nearbyStores.length === 1 ? 1 : 2, [nearbyStores.length]) }}
			</span>
			<span v-else-if="location">{{ $t('no nearby stores found') }}</span>
			<span v-else>{{ $t('setDeliveryLocation') }}</span>
		</h5>
		<b-button
			v-for="(store, index) in nearbyStores"
			:key="index"
			variant="outline-primary"
			size="sm"
			:class="{
				border: true,
				active: selectedStore && store.id === selectedStore.id,
				'mr-3': index < nearbyStores.length - 1
			}"
			pill
			@click="setSelectedStore(store)"
		>
			<b-icon-shop class="mr-1" />
			<span class="text-capitalize">{{ store.name }}</span>
		</b-button>
		<b-button
			v-if="nearbyStores.length === 0"
			variant="outline-primary border"
			pill
			@click="$root.$emit('changeDeliveryLocation')"
		>
			<b-icon-geo class="mr-1" />
			{{ location ? $t('change delivery location') : $t('set delivery location') }}
		</b-button>
	</div>
</template>

<script>
	export default {
		computed: {
			location () {
				return this.$store.state.location
			},
			nearbyStores: {
				get () {
					return this.$store.state.nearbyStores
				},
				set (value) {
					this.$store.commit('setState', {
						key: 'nearbyStores',
						value
					})
				}
			},
			selectedStore: {
				get () {
					return this.$store.state.selectedStore
				},
				set (store) {
					this.$store.commit('setSelectedStore', store)
				}
			}
		},
		methods: {
			setSelectedStore (store) {
				this.selectedStore = store
				this.$emit('change')
			}
		}
	}
</script>

<style lang="css" scoped>
</style>
